import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const MainPage = lazy(() => import('../pages/main/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const CompanyListPage = lazy(() => import('../pages/company-list/page'));
const CompanyRegisterPage = lazy(() => import('../pages/company-register/page'));
const CompanyDetailPage = lazy(() => import('../pages/company-detail/page'));
const UserManagementPage = lazy(() => import('../pages/user-management/page'));
const CallManagementPage = lazy(() => import('../pages/call-management/page'));
const DataUploadPage = lazy(() => import('../pages/data/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <MainPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/company-list',
    element: <CompanyListPage />,
  },
  {
    path: '/company-register',
    element: <CompanyRegisterPage />,
  },
  {
    path: '/company/:id',
    element: <CompanyDetailPage />,
  },
  {
    path: '/user-management',
    element: <UserManagementPage />,
  },
  {
    path: '/call-management',
    element: <CallManagementPage />,
  },
  {
    path: '/data-upload',
    element: <DataUploadPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
